import { ScanToPayBottomCard } from './ScanToPayBottomCard';
import { ScanToPayContainer } from './ScanToPayContainer';
import { ScanToPayCreditBalance } from './ScanToPayCreditBalance';
import { ScanToPayEmptyState } from './ScanToPayEmptyState';
import { ScanToPayErrorState } from './ScanToPayErrorState';
import { ScanToPayFaqCta } from './ScanToPayFaqCta';
import { ScanToPayFaqModal } from './ScanToPayFaqModal';
import { ScanToPayFooter } from './ScanToPayFooter';
import { ScanToPayLoadingState } from './ScanToPayLoadingState';
import { ScanToPayPaymentMethod } from './ScanToPayPaymentMethod';
import { ScanToPayPaymentSelectionModal } from './ScanToPayPaymentSelectionModal';
import { ScanToPayPointsCta } from './ScanToPayPointsCta';
import { ScanToPayPointsModal } from './ScanToPayPointsModal';
import { ScanToPayQrCode } from './ScanToPayQrCode';
import { ScanToPayTab } from './ScanToPayTab';
import { ScanToPayTabsContainer } from './ScanToPayTabsContainer';
import { ScanToPayTabsHeader } from './ScanToPayTabsHeader';

export const ScanToPay = {
  TabsContainer: ScanToPayTabsContainer,
  TabsHeader: ScanToPayTabsHeader,
  Tab: ScanToPayTab,

  Container: ScanToPayContainer,
  Footer: ScanToPayFooter,

  BottomCard: ScanToPayBottomCard,
  CreditBalance: ScanToPayCreditBalance,

  PaymentMethod: ScanToPayPaymentMethod,
  PaymentSelectionModal: ScanToPayPaymentSelectionModal,

  FaqCta: ScanToPayFaqCta,
  FaqModal: ScanToPayFaqModal,

  PointsCta: ScanToPayPointsCta,
  PointsModal: ScanToPayPointsModal,

  QrCode: ScanToPayQrCode,

  LoadingState: ScanToPayLoadingState,
  EmptyState: ScanToPayEmptyState,
  ErrorState: ScanToPayErrorState,
};
